module.exports = __webpack_public_path__ + "static/media/connected.a5c19e3d.svg";